const { addPartToVM } = require("./utils/add-part");
const {
  initializePrototypes,
} = require("./utils/scratch/object-prototypes.js");
const log = require("../shared_utils/log.js");
const { deserializeSnapshot } = require("./utils/import-export-helpers.js");
const { loadSnapshot } = require("./utils/load-snapshot");
function clearIoDevices(runtime) {
  for (const deviceName in runtime.ioDevices) {
    if (deviceName) {
      const device = runtime.ioDevices[deviceName];
      if (device) {
        runtime.ioDevices[deviceName] = new device.constructor(runtime);
      }
    }
  }
}

module.exports = function store(state, emitter) {
  function loadSceneFromProjectData(sceneToLoad, vm) {
    state.addedParts = [];
    state.glitchApplications = [];
    return vm.loadProject(sceneToLoad.sb3).then(() => {
      vm.runtime.greenFlag();
      initializePrototypes(vm);
      if (sceneToLoad.snapshot) {
        return state.vm.loadProject(sceneToLoad.sb3).then(() => {
          const addPartPromises = [];
          sceneToLoad.snapshot.stateData.addedParts.forEach(
            (addedPartEntry) => {
              const partToAdd = state.availableParts.find(
                (part) => part.id === addedPartEntry.partId
              );
              if (partToAdd) {
                addPartPromises.push(
                  addPartToVM(partToAdd, state.vm, {
                    name: addedPartEntry.spriteName,
                  })
                );
              } else {
                sceneToLoad.snapshot = removeMissingPartFromSnapshot(
                  sceneToLoad.snapshot,
                  addedPartEntry.partId
                );
              }
            }
          );
          return Promise.all(addPartPromises).then((addedParts) => {
            const snapshotDeserialized = deserializeSnapshot(
              sceneToLoad.snapshot,
              state.vm
            );
            sceneToLoad.snapshotDeserialized = snapshotDeserialized;
            state.currentScene = sceneToLoad;
            loadSnapshot(snapshotDeserialized, state);
            return sceneToLoad;
          });
        });
      }
    });
  }

  function removeMissingPartFromSnapshot(snapshot, partId) {
    snapshot.stateData.addedParts = snapshot.stateData.addedParts.filter(
      (part) => part.partId !== partId
    );
    const target = snapshot.vmData.targets.find((t) => t.sprite === partId);
    if (!target) {
      return snapshot;
    }
    const targetId = target.id;
    snapshot.stateData.glitchApplications =
      snapshot.stateData.glitchApplications.filter(
        (g) => g.targetId !== targetId
      );
    snapshot.stateData.hiddenTargets = snapshot.stateData.hiddenTargets.filter(
      (t) => t !== targetId
    );

    // delete taret id entry fomr snapshot.physicsData.bodies whic his a dictioanry with id as key

    // and body as value
    delete snapshot.stateData.physicsData.bodies[targetId];
    snapshot.vmData.targets = snapshot.vmData.targets.filter(
      (t) => t.id !== targetId
    );
    snapshot.vmData.executableTargets =
      snapshot.vmData.executableTargets.filter((t) => t !== targetId);
    snapshot.vmData.threads = snapshot.vmData.threads.filter(
      (t) => t.targetId !== targetId
    );
    snapshot.vmData.targetLayers = snapshot.vmData.targetLayers.filter(
      (t) => t !== targetId
    );

    return snapshot;
  }

  emitter.on("load-scene", (sceneIndex, resetScene) => {
    log("load-scene", sceneIndex);
    state.sceneIsLoading = true;
    if (state.currentScene) {
      if (!state.currentHistoryItem) {
        emitter.emit("push-history", "switch-scenes");
      } else {
        state.getHistory().push(state.currentHistoryItem);
      }
    }
    state.currentHistoryItem = null;
    emitter.emit("pause");

    const sceneToLoad = state.project.scenes[sceneIndex];

    let _currentTutorialStep, _currentTutorial, _toolbar;
    if (state.toolbar) {
      _toolbar = JSON.parse(JSON.stringify(state.toolbar));
    }

    if (!state.isLoadingSceneForDeletion && state.projectMetadata.tutorials) {
      _currentTutorial = state.projectMetadata.tutorials[sceneIndex];
      if (_currentTutorial) {
        _currentTutorialStep = _currentTutorial.startingStepId;
        _toolbar = _currentTutorial[_currentTutorialStep].toolbar;
      }
    }

    if (sceneToLoad) {
      let playingTutorialOverride = state.playingTutorial;

      const penSkin = state.vm.runtime.renderer._allSkins.find(
        (skin) => skin.constructor.name === "PenSkin"
      );
      if (penSkin) {
        state.vm.runtime.renderer.penClear(penSkin._id);
      }
      if (
        state.histories[sceneToLoad.metadata.id] &&
        state.histories[sceneToLoad.metadata.id].length > 0
      ) {
        if (resetScene) {
          //the first history item is the initial state of the scene
          state.histories[sceneToLoad.metadata.id].splice(1);
        }
        state.currentScene = sceneToLoad;
        emitter.emit("pop-history");
        state.sceneIsLoading = false;
        filterGlitches();
        state.future = [];
        if (!state.isLoadingSceneForDeletion) {
          state.currentTutorialStep = _currentTutorialStep;
          state.currentTutorial = _currentTutorial;
          if (_toolbar) {
            state.toolbar = _toolbar;
          }
        }
        emitter.emit("load-complete");
        if (!playingTutorialOverride) {
          state.currentTutorial = null;
          state.playingTutorial = false;
          state.currentTutorialStep = null;
          state.previousTutorialStep = null;
        }
        setTimeout(() => {
          emitter.emit("render");
        }, 20);
      } else {
        loadSceneFromProjectData(
          state.project.scenes[sceneIndex],
          state.vm
        ).then((sceneData) => {
          state.currentScene = sceneToLoad;
          filterGlitches();
          state.future = [];
          emitter.emit("load-complete");
          state.sceneIsLoading = false;
          if (!state.isLoadingSceneForDeletion) {
            state.currentTutorialStep = _currentTutorialStep;
            state.currentTutorial = _currentTutorial;
            if (_currentTutorial) {
              state.toolbar = _toolbar;
            }
          }
          setTimeout(() => emitter.emit("render"), 20);
        });
      }
    } else {
      throw Error(`Scene ${sceneIndex} not found`);
    }
  });

  emitter.on("load-complete", () => {
    state.isLoadingSceneForDeletion = false;
    emitter.emit("add-document-event-listeners");
    const _showLevelsPanel = state.showLevelsPanel;

    emitter.emit("refresh-glitches");
    emitter.emit("refresh-parts");
    clearIoDevices(state.vm.runtime);
    emitter.emit("deselect-all");
    state.showLevelsPanel = _showLevelsPanel;
    state.vm.runtime.currentStepTime = 1;
    state.loadedVM = true;
    emitter.emit("render");
  });

  function filterGlitches() {
    state.glitchApplications = state.glitchApplications.filter((g) =>
      state.availableGlitches.find((ag) => ag.id === g.glitchId)
    );
    state.toolbar.glitches = state.toolbar.glitches.filter((g) =>
      state.availableGlitches.find((ag) => ag.id === g)
    );
  }
};
